
export { default as Lottie } from "./Lottie"